export default "__VITE_ASSET__DlJg50AH__"